import { IIteam } from "../types/types";



export const items: IIteam[] = [
 {
  category: {
    name: "forHim",
    id: 'hats',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'awesome cap',
  image: '/cloth/forHim/hats/753fd74b8db0a850fd97f9e1c7051875.jpeg',
  price: 30,
  slug: '',
  title: "coolest cap ever",
  id: '101',
  },
 {
  category: {
    name: "forHim",
    id: 'hats',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'cool cap',
  image: '/cloth/forHim/hats/946b9f5a27683b79f04e995ff2b23ffc.jpeg',
  price: 10,
  slug: '',
  title: "coolest cap ever",
  id: '102',
  },
 {
  category: {
    name: "forHim",
    id: 'pants',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'cool pants',
  image: '/cloth/forHim/pants/-1117Wx1400H-441103086-beige-MODEL.webp',
  price: 99,
  slug: '',
  title: "coolest pants ever",
  id: '103',
  },
 {
  category: {
    name: "forHim",
    id: 'pants',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'awesome pants',
  image: '/cloth/forHim/pants/-1117Wx1400H-441103086-darkblue-MODEL.webp',
  price: 120,
  slug: '',
  title: "coolest pants ever",
  id: '104',
  },
  {
    category: {
      name: "forHim",
      id: 'shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool shirt',
    image: '/cloth/forHim/shirts/2414a8641f7b13b37fea76ec8723a662.jpeg',
    price: 68,
    slug: '',
    title: "coolest shirt ever",
    id: '105',
    },
   {
    category: {
      name: "forHim",
      id: 'shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome shirt',
    image: '/cloth/forHim/shirts/men-slim-fit-shirt-500x500.jpeg',
    price: 120,
    slug: '',
    title: "coolest shirt ever",
    id: '106',
    },
  {
    category: {
      name: "forHim",
      id: 'snickers',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool snickers',
    image: '/cloth/forHim/snickers/b8e261a19a90d344b7d5fd9a4a56822b.jpeg',
    price: 245,
    slug: '',
    title: "coolest snickers ever",
    id: '107',
    },
   {
    category: {
      name: "forHim",
      id: 'snickers',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome snickers',
    image: '/cloth/forHim/snickers/images.jpeg',
    price: 150,
    slug: '',
    title: "coolest shirt ever",
    id: '108',
    },
  {
    category: {
      name: "forHim",
      id: 'sportswear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool sportswear',
    image: '/cloth/forHim/sportswear/13480831-1704927551644325.jpeg',
    price: 205,
    slug: '',
    title: "coolest snickers ever",
    id: '109',
    },
   {
    category: {
      name: "forHim",
      id: 'sportswear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome sportswear',
    image: '/cloth/forHim/sportswear/200500689-1-greymarl.webp',
    price: 170,
    slug: '',
    title: "coolest shirt ever",
    id: '110',
    },
  {
    category: {
      name: "forHim",
      id: 't-shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool t-shirt',
    image: '/cloth/forHim/t-shirts/65a08bf4ba1ac8f879fcf823a4e0cabb.jpeg',
    price: 45,
    slug: '',
    title: "coolest t-shirt ever",
    id: '111',
    },
   {
    category: {
      name: "forHim",
      id: 't-shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome t-shirt',
    image: '/cloth/forHim/t-shirts/5533395a9817136c42b3b83c573c368e.jpeg',
    price: 50,
    slug: '',
    title: "coolest t-shirt ever",
    id: '112',
    },
  {
    category: {
      name: "forHim",
      id: 'underwear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool underwear',
    image: '/cloth/forHim/underwear/collins-boxer-190982.webp',
    price: 15,
    slug: '',
    title: "coolest underwear ever",
    id: '113',
    },
   {
    category: {
      name: "forHim",
      id: 'underwear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome underwear',
    image: '/cloth/forHim/underwear/you-can-count-me-have-your-back-rearview-shot-unrecognizable-man-posing-underwear-against-grey-background_590464-31197.webp',
    price: 20,
    slug: '',
    title: "coolest underwear ever",
    id: '114',
    },
 {
  category: {
    name: "forHer",
    id: 'hats',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'awesome cap',
  image: '/cloth/forHer/hats/img_x300_613e91543952c9-53832801-78894514.jpeg',
  price: 30,
  slug: '',
  title: "coolest cap ever",
  id: '115',
  },
 {
  category: {
    name: "forHer",
    id: 'hats',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'cool cap',
  image: '/cloth/forHer/hats/img_x300_61906f02682164-62028215-48509113.jpeg',
  price: 10,
  slug: '',
  title: "coolest cap ever",
  id: '116',
  },
 {
  category: {
    name: "forHer",
    id: 'pants',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'cool pants',
  image: '/cloth/forHer/pants/10-80-112822-80519-find-1000-02-1539934386-500x500.jpeg',
  price: 99,
  slug: '',
  title: "coolest pants ever",
  id: '117',
  },
 {
  category: {
    name: "forHer",
    id: 'pants',
  },
  createdAt: "2022-07-08",
  createdBy: {
    name: 'KRVN studio',
    id: '1001',
  },
  description: 'awesome pants',
  image: '/cloth/forHer/pants/U7eb2b1016a8441429e0dcbb3f92b7f10E.jpeg',
  price: 120,
  slug: '',
  title: "coolest pants ever",
  id: '118',
  },
  {
    category: {
      name: "forHer",
      id: 'shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool shirt',
    image: '/cloth/forHer/shirts/441906.jpeg',
    price: 68,
    slug: '',
    title: "coolest shirt ever",
    id: '119',
    },
   {
    category: {
      name: "forHer",
      id: 'shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome shirt',
    image: '/cloth/forHer/shirts/5059190349432.jpeg',
    price: 120,
    slug: '',
    title: "coolest shirt ever",
    id: '120',
    },
  {
    category: {
      name: "forHer",
      id: 'snickers',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool snickers',
    image: '/cloth/forHer/snickers/big-star-white-womens-sneakers-w274835-270x270.jpeg',
    price: 245,
    slug: '',
    title: "coolest snickers ever",
    id: '121',
    },
   {
    category: {
      name: "forHer",
      id: 'snickers',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome snickers',
    image: '/cloth/forHer/snickers/ellx-women-snickersz-2988-2-550x550.jpeg',
    price: 150,
    slug: '',
    title: "coolest shirt ever",
    id: '122',
    },
  {
    category: {
      name: "forHer",
      id: 'sportswear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool sportswear',
    image: '/cloth/forHer/sportswear/f4b4c9d68f2593c4d7a85ac8c41d1fc8.jpeg',
    price: 205,
    slug: '',
    title: "coolest snickers ever",
    id: '123',
    },
   {
    category: {
      name: "forHer",
      id: 'sportswear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome sportswear',
    image: '/cloth/forHer/sportswear/SSS2_NKDJ6774_010_195239556814_3.webp',
    price: 170,
    slug: '',
    title: "coolest shirt ever",
    id: '124',
    },
  {
    category: {
      name: "forHer",
      id: 't-shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool t-shirt',
    image: '/cloth/forHer/t-shirts/3641302250_2_1_1.jpeg',
    price: 45,
    slug: '',
    title: "coolest t-shirt ever",
    id: '125',
    },
   {
    category: {
      name: "forHer",
      id: 't-shirts',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome t-shirt',
    image: '/cloth/forHer/t-shirts/images.jpeg',
    price: 50,
    slug: '',
    title: "coolest t-shirt ever",
    id: '126',
    },
  {
    category: {
      name: "forHer",
      id: 'underwear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'cool underwear',
    image: '/cloth/forHer/underwear/O1BM12KA5I0-G4O9.webp',
    price: 15,
    slug: '',
    title: "coolest underwear ever",
    id: '127',
    },
   {
    category: {
      name: "forHer",
      id: 'underwear',
    },
    createdAt: "2022-07-08",
    createdBy: {
      name: 'KRVN studio',
      id: '1001',
    },
    description: 'awesome underwear',
    image: '/cloth/forHer/underwear/Uaa94e7e84a144b3085e8cac4db2a67f6Q.jpg_.webp',
    price: 20,
    slug: '',
    title: "coolest underwear ever",
    id: '128',
    },
]